var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject, transient } from 'aurelia-dependency-injection';
import { DialogClientService } from '../../../../../services/basics/dialog-client.service';
import * as Enumerable from "linq";
import { SourceType } from "../../../../../models/queries/queries.models";
import { QueriesClientService } from "../../../../../services/queries/queries-client.services";
import { QueriesEditor } from "../../../../components/queries/queries-editor";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { Router } from "aurelia-router";
import { RouterConstants } from "../../../../../configuration/router.constants";
import { I18N } from 'aurelia-i18n';
import { ChildComponent } from '../../../../pages/modules/child-component';
var LotteriesByOperatorCurrencyDialog = /** @class */ (function (_super) {
    __extends(LotteriesByOperatorCurrencyDialog, _super);
    function LotteriesByOperatorCurrencyDialog(notificationService, queriesService, router, dialogClient, i18N) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.notificationService = notificationService;
        _this.queriesService = queriesService;
        _this.router = router;
        _this.dialogClient = dialogClient;
        return _this;
    }
    LotteriesByOperatorCurrencyDialog.prototype.close = function () {
        this.dialogClient.hide();
    };
    LotteriesByOperatorCurrencyDialog.prototype.onActivated = function (brandsAndOperators) {
        this.getLotteryBrandOperatorsOdata(brandsAndOperators);
    };
    LotteriesByOperatorCurrencyDialog.prototype.getLotteryBrandOperatorsOdata = function (brandsAndOperators) {
        var _this = this;
        this.queriesService.getEntityModels().then(function (models) { return __awaiter(_this, void 0, void 0, function () {
            var columns, selectedModel, _a, _b, item, column;
            var e_1, _c;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        columns = [];
                        selectedModel = Enumerable.from(models).firstOrDefault(function (y) { return y.uri == _this.oDataUrlTerm(brandsAndOperators); });
                        try {
                            for (_a = __values(selectedModel.projectionProperties), _b = _a.next(); !_b.done; _b = _a.next()) {
                                item = _b.value;
                                column = QueriesEditor.generateDefaultColumn(item, selectedModel);
                                columns.push(column); // over here we are showing lottery id and lottery name as a columns to show list of lotteries
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        return [4 /*yield*/, this.createDataGridList(brandsAndOperators, columns)];
                    case 1:
                        _d.sent();
                        return [2 /*return*/];
                }
            });
        }); }).catch(function (error) {
            _this.notificationService.show(_this.i18N.tr('error-text') + "!", _this.i18N.tr('error-loading-meta-data-for-query-editor-text'), NotificationType.Error);
        });
    };
    LotteriesByOperatorCurrencyDialog.prototype.createDataGridList = function (brandsAndOperators, columns) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.queriesService.getData(this.oDataUrlPath(brandsAndOperators)).then(function (response) {
                            _this.itemSource = {
                                source: response.value,
                                sourceType: SourceType.Collection,
                                columns: columns,
                                groupInitialFilters: true
                            };
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.itemSource.source.length];
                }
            });
        });
    };
    LotteriesByOperatorCurrencyDialog.prototype.oDataUrlTerm = function (brandsAndOperators) {
        if (brandsAndOperators.operatorId != null)
            return "LotteriesDoesNotHaveOperatorCurrencies";
    };
    LotteriesByOperatorCurrencyDialog.prototype.oDataUrlPath = function (brandsAndOperators) {
        if (brandsAndOperators.operatorId != null)
            return "/odata/".concat(this.oDataUrlTerm(brandsAndOperators), "?operatorId=").concat(brandsAndOperators.operatorId, "&currencyId=").concat(brandsAndOperators.currencyId);
    };
    LotteriesByOperatorCurrencyDialog.prototype.onItemSelected = function (x) {
        var item = x.detail.item;
        window.open(this.router.generate(RouterConstants.RouteNames.ManageLottery, {
            id: item.lotteryId, operatorId: item.operatorId, operatorName: item.operator,
            operatorDefaultCurrencyId: item.defaultCurrencyId,
            isOpenedFromLotteryAdmin: false, isOpenedFromBrandAdmin: false,
        }), '_blank');
    };
    LotteriesByOperatorCurrencyDialog = __decorate([
        transient(),
        autoinject(),
        __metadata("design:paramtypes", [NotificationClientService,
            QueriesClientService,
            Router,
            DialogClientService, I18N])
    ], LotteriesByOperatorCurrencyDialog);
    return LotteriesByOperatorCurrencyDialog;
}(ChildComponent));
export { LotteriesByOperatorCurrencyDialog };
